module.exports = __webpack_public_path__ + "img/ic-amex-white.2c269f12.svg";